import React from "react";

import Joi from "joi-browser";
import Form from "../common/Form";

import db from "../../services/query";
import lbl from "../../data/Labels.json";

import { PopUpContext } from "../../contexts/popUpContext";

class SubjectForm extends Form {
  static contextType = PopUpContext;

  state = {
    drp: {
      department: [],
      faculty: [],
    },
    data: {
      subject_code: "",
      subject_name: "",
      subject_name_en: "",
      department: "",
      faculty: "",
      credits: "",
      is_practical: "",
      obsolete: "",
    },
    errors: {},
  };

  componentDidMount = async () => {
    const { drp, data } = this.state;

    const {
      popUp: { edit },
    } = this.context;

    if (edit) {
      data.subject_code = edit.subject_code;
      data.subject_name = edit.subject_name;
      data.subject_name_en = edit.subject_name_en;
      data.department = edit.department_id;
      data.faculty = edit.faculty_id;
      data.credits = edit.credits;
      data.is_practical = edit.is_practical;
      data.obsolete = edit.obsolete;
    }

    await db
      .getAll(`dropdowns/departments`)
      .then(({ data: { data } }) => (drp["department"] = data));

    await db
      .getAll(`dropdowns/faculties`)
      .then(({ data: { data } }) => (drp["faculty"] = data));

    this.setState({ drp, data });
  };

  schema = {
    subject_code: Joi.string().max(16).required(),
    subject_name: Joi.string().max(256).required(),
    subject_name_en: Joi.string().max(256).required(),
    department: Joi.number(),
    faculty: Joi.number().required(),
    credits: Joi.number().required(),
    is_practical: Joi.number(),
    obsolete: Joi.number(),
  };

  doSubmit = async () => {
    try {
      const { togglePopUp, popUp } = this.context;

      const __controls = this.cleanObject({
        ...this.state.data,
      });

      if (popUp?.edit) {
        await db
          .edit(`subjects/${popUp?.edit?.subject_id}`, __controls)
          .then(() => {
            togglePopUp({ form: "toast" });
          })
          .catch((err) => {
            togglePopUp({
              form: "toast",
              message: err.toString(),
              type: "warning",
            });
          });
      } else {
        await db
          .save("subjects", __controls)
          .then(() => {
            togglePopUp({ form: "toast" });
          })
          .catch((err) => {
            togglePopUp({
              form: "toast",
              message: err.toString(),
              type: "warning",
            });
          });
      }
    } catch ({ response }) {
      if (response && response.status === 400) {
        const errors = { ...this.state.error };

        this.setState({ errors });
      }
    }
  };

  render() {
    const { drp } = this.state;
    const { popUp } = this.context;

    return (
      <div className="form-container">
        <form className="form crud" onSubmit={this.handleSubmit}>
          <div className="head">
            <p>{popUp?.edit ? lbl.EditSubject : lbl.AddSubject}</p>
          </div>
          <div className="form-inputs">
            <div className="multi-input">
              {this.renderInput("subject_name", "نام (فارسی)")}
              {this.renderInput("subject_name_en", "نام (انگلیسی)")}
            </div>
            <div className="multi-input">
              {this.renderSelect("faculty", "پوهنحی", drp.faculty)}
              {this.renderSelect("department", "دیپارتمنت", drp.department)}
            </div>
            <div className="multi-input">
              {this.renderInput("subject_code", "کد مضمون")}
              {this.renderInput("credits", "تعداد کریدت", "number")}
            </div>
            <div className="multi-input checkbox">
              {this.renderCheckBox("is_practical", "", "عملی")}
              {this.renderCheckBox("obsolete", "", "غیر فعال")}
            </div>
          </div>
          <div className="form-buttons">
            {this.renderButton(popUp?.edit ? lbl.Edit : lbl.Save)}
          </div>
        </form>
      </div>
    );
  }
}

export default SubjectForm;
